import moment from "moment";
import * as Yup from "yup";
import { REGEXES } from "./regex";
import { VALIDATION_TEXTS } from "../helpers/STRING_CONSTANTS";

Yup.addMethod(Yup.array, "unique", function (message, mapper = (a) => a) {
  return this.test("unique", message, function (list) {
    return list.length === new Set(list.map(mapper)).size;
  });
});

const phoneRegExp =
  /((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[014-9]|3[0-469]|2[70]|7|1)(?:\W*\d){0,14}\d$/;
export const loginSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password is at least 6 characters")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
});

export const createVisitorBookingValidation = Yup.object().shape({
  category: Yup.string().required("This field is required."),
  startDate: Yup.date()
    .typeError("Enter a start date.")
    .required("Start date is required."),
  endDate: Yup.date()
    .typeError("Enter an end date.")
    .required("End date is required."),
  startTime: Yup.date()
    .typeError("Enter a start time.")
    .required("Start time is required."),
  endTime: Yup.date()
    .typeError("Enter an end time.")
    // .min(Yup.ref("startTime"), "End time must be after start time")
    .required("End time is required."),

  // number of entries not required if category is delivery
  noOfEntries: Yup.string().when("category", {
    is: (category) => category !== "delivery",
    then: Yup.string().required("Choose an entry type."),
    otherwise: Yup.string(),
  }),

  inviteSource: Yup.string().when("category", {
    is: (category) => category === "general-visitor",
    then: Yup.string().required("Select an invite source"),
    otherwise: Yup.string(),
  }),

  firstName: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "delivery" ||
      (category === "general-visitor" && inviteSource === "new"),
    then: Yup.string().required("First name is required."),
    otherwise: Yup.string(),
  }),
  lastName: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "delivery" ||
      (category === "general-visitor" && inviteSource === "new"),
    then: Yup.string().required("Last name is required."),
    otherwise: Yup.string(),
  }),

  handyInviteSource: Yup.string().when(["category"], {
    is: (category) => category === "handy-person",
    then: Yup.string().required("Choose an invite source."),
    otherwise: Yup.string(),
  }),

  jobId: Yup.string().when(["category"], {
    is: (category) => category === "handy-person",
    then: Yup.string().required("Enter a Job ID."),
    otherwise: Yup.string(),
  }),
  name: Yup.string(),
  handyServiceName: Yup.string().when(["category", "handyInviteSource"], {
    is: (category, handyInviteSource) =>
      category === "handy-person" && handyInviteSource === "new",
    then: Yup.string().required("Name is required."),
    otherkwise: Yup.string(),
  }),

  gender: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "delivery" ||
      category === "handy-person" ||
      (category === "general-visitor" && inviteSource === "new"),
    then: Yup.string().required("Gender is required."),
    otherwise: Yup.string(),
  }),
  email: Yup.string().email(),
  address: Yup.string(),
  // saveVisitor: Yup.boolean(),
  // sendEmail: Yup.boolean(),
  savedVisiorId: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "general-visitor" && inviteSource === "saved-visitor",
    then: Yup.string().required("Choose a saved visitor."),
    otherwise: Yup.string(),
  }),
  visitorGroupId: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "general-visitor" && inviteSource === "visitor-groups",
    then: Yup.string().required("Choose a group."),
    otherwise: Yup.string(),
  }),
});

export const editVisitorBookingValidation = Yup.object().shape({
  category: Yup.string().required("This field is required."),
  endDate: Yup.date()
    .typeError("Enter a end date.")
    .required("End date is required."),
  startTime: Yup.date()
    .typeError("Enter a start time.")
    .required("Start time is required."),
  endTime: Yup.date()
    .typeError("Enter a end time.")
    // .min(Yup.ref("startTime"), "End time must be after start time")
    .required("End time is required."),
  startDate: Yup.date()
    .min(new Date(), "Date must be later than today.")
    .typeError("Enter a start date.")
    .required("Start date is required."),

  // number of entries not required if category is delivery
  noOfEntries: Yup.string().when("category", {
    is: (category) => category !== "delivery",
    then: Yup.string().required("Choose an entry type."),
    otherwise: Yup.string(),
  }),

  inviteSource: Yup.string().when("category", {
    is: (category) => category === "general-visitor",
    then: Yup.string().required("Select an invite source"),
    otherwise: Yup.string(),
  }),

  firstName: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "delivery" ||
      (category === "general-visitor" && inviteSource === "new"),
    then: Yup.string().required("First name is required."),
    otherwise: Yup.string(),
  }),
  lastName: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "delivery" ||
      (category === "general-visitor" && inviteSource === "new"),
    then: Yup.string().required("Last name is required."),
    otherwise: Yup.string(),
  }),

  handyInviteSource: Yup.string().when(["category"], {
    is: (category) => category === "handy-person",
    then: Yup.string().required("Choose an invite source."),
    otherwise: Yup.string(),
  }),

  jobId: Yup.string().when(["category"], {
    is: (category) => category === "handy-person",
    then: Yup.string().required("Enter a Job ID."),
    otherwise: Yup.string(),
  }),
  name: Yup.string(),
  handyServiceName: Yup.string().when(["category", "handyInviteSource"], {
    is: (category, handyInviteSource) =>
      category === "handy-person" && handyInviteSource === "new",
    then: Yup.string().required("Name is required."),
    otherwise: Yup.string(),
  }),

  gender: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "delivery" ||
      category === "handy-person" ||
      (category === "general-visitor" && inviteSource === "new"),
    then: Yup.string().required("Gender is required."),
    otherwise: Yup.string(),
  }),
  email: Yup.string().email(),
  address: Yup.string(),
  // saveVisitor: Yup.boolean(),
  // sendEmail: Yup.boolean(),
  savedVisiorId: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "general-visitor" && inviteSource === "saved-visitor",
    then: Yup.string().required("Choose a saved visitor."),
    otherwise: Yup.string(),
  }),
  visitorGroupId: Yup.string().when(["category", "inviteSource"], {
    is: (category, inviteSource) =>
      category === "general-visitor" && inviteSource === "visitor-groups",
    then: Yup.string().required("Choose a group."),
    otherwise: Yup.string(),
  }),
});

export const createGroupSchema = Yup.object().shape({
  groupName: Yup.string().required("This field is required"),
  groupRetainedDate: Yup.string().required("This field is required"),
});

export const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .min(4, "Password should be at least 4 characters")
    .required("Required"),
  newPassword: Yup.string()
    .min(4, "Password should be at least 4 characters")
    .required("Required"),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Required"),
});

export const resetPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(4, "Password should be at least 4 characters")
    .required("Required"),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Required"),
});

export const updatePasswordSchema = Yup.object().shape({
  userId: Yup.string().required("Required"),
  token: Yup.string().required("Required"),
  newPassword: Yup.string()
    .min(4, "Password should be at least 4 characters")
    .required("Required"),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Required"),
});

export const updateNationalIdSchema = Yup.object().shape({
  userId: Yup.string().required("Required"),
  token: Yup.string().required("Required"),
  newNationalId: Yup.string()
    .min(4, "National ID should have at least 5 characters")
    .required("Required"),
  confirmNewNationalId: Yup.string()
    .oneOf([Yup.ref("newNationalId"), null], "National IDS must match")
    .required("Required"),
});

export const updateEmailSchema = Yup.object().shape({
  userId: Yup.string().required("Required"),
  token: Yup.string().required("Required"),
  newEmail: Yup.string().email("Invalid email").required("Required"),
});

export const updatePhoneSchema = Yup.object().shape({
  userId: Yup.string().required("Required"),
  token: Yup.string().required("Required"),
});

export const otpSchema = Yup.object().shape({
  pin: Yup.string().required("Pin is required"),
});

export const addUnitTypeSchema = Yup.object().shape({
  categoryId: Yup.string().required("This field is required"),
  name: Yup.string().required("This field is required"),
  description: Yup.string(),
  maxPrimeMemberLimit: Yup.number("Only numbers allowed"),
  maxSquadMemberLimit: Yup.number("Only numbers allowed"),
});

export const EditDefaultUnitTypeSchema = Yup.object().shape({
  maxPrimeMemberLimit: Yup.number("Only numbers allowed").required(
    "This field is required."
  ),
  maxSquadMemberLimit: Yup.number("Only numbers allowed").required(
    "This field is required."
  ),
});

export const forgotPassSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required"),
});

export const confirmAccessSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password is at least 6 characters")
    .required("Required"),
});

export const changeEmailSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required"),
});

export const editUnitSchema = Yup.object().shape({
  unitData: Yup.array().required("This field is required"),
});

export const editBillSchema = Yup.object().shape({
  categoryId: Yup.string().required("Payment type is required"),
  title: Yup.string().required("Payment name is required"),
  duePeriod: Yup.number().required("Due Period is required"),
  flexibility: Yup.array().required("This field is required"),
  restrictions: Yup.array().required("This field is required"),
  gracePeriod: Yup.number()
    .min(1, "Enter a number above 0")
    .required("This field is required"),
});

export const AddBillerCategorySchema = Yup.object().shape({
  billerCategoryName: Yup.string().required("Category name is required."),
  appCategoryGroup: Yup.number().required("Choose an app group."),
  billerInfo: Yup.array()
    .of(
      Yup.object().shape({
        billerName: Yup.string().required("This field is required."),
        // isHidden: Yup.boolean().notRequired(),
        billerCategory: Yup.string(),
        // addSubCat: false,
        // generalSelectedBillers: [],
        billers: Yup.array().of(
          Yup.object().shape({
            id: Yup.string().notRequired(),
            name: Yup.string().notRequired(),
            // isHidden: false,
            providerId: Yup.string().required("Choose a biller"),
            logoUrl: Yup.string().notRequired(),
            categoryName: Yup.string().notRequired(),
            // categoryGroup: Yup.number().notRequired(),
            packages: Yup.array()
              .required("Biller packages is required")
              .min(1, "No packages added"),
          })
        ),
      })
    )
    .required()
    .min(1),
});

export const MainEditBillerCategorySchema = Yup.object().shape({
  billerCategoryName: Yup.string().required("Category name is required."),
  appCategoryGroup: Yup.number().required("Choose an app group."),
  // billerInfo: Yup.array()
  //   .required()
  //   .min(1, "There must be atleast one biller added."),
});
export const ComposeMailSchema = Yup.object().shape({
  sendTo: Yup.array().notRequired(),
  subject: Yup.string().required("This field is required."),
  responseRecipients: Yup.array().notRequired(),
  content: Yup.string().required("This field is required."),
  category: Yup.string().required("This field is required."),
});
export const ComposeNewsletterSchema = Yup.object().shape({
  subject: Yup.string().required("This field is required."),
  content: Yup.string().required("This field is required."),
  templateId: Yup.string().required("Please choose a template"),
});

export const EditBillerCategorySchema = Yup.object().shape({
  billerInfo: Yup.array()
    .of(
      Yup.object().shape({
        billerName: Yup.string().required("This field is required."),
        // isHidden: Yup.boolean().notRequired(),
        billerCategory: Yup.string(),
        // addSubCat: false,
        // generalSelectedBillers: [],
        billers: Yup.array().of(
          Yup.object().shape({
            id: Yup.string().notRequired(),
            name: Yup.string().notRequired(),
            // isHidden: false,
            providerId: Yup.string().required("Choose a biller"),
            logoUrl: Yup.string().notRequired(),
            categoryName: Yup.string().notRequired(),
            // categoryGroup: Yup.number().notRequired(),
            packages: Yup.array()
              .required("Biller packages is required")
              .min(1, "No packages added"),
          })
        ),
      })
    )
    .notRequired(),
});

export const profileSchema = Yup.object().shape(
  {
    fullName: Yup.string(),
    firstName: Yup.string().required("This field is required"),
    lastName: Yup.string().required("This field is required"),
    username: Yup.string().notRequired(),
    recoveryEmail: Yup.string().email("This email is invalid").notRequired(),
    email: Yup.string()
      .email("This email is invalid")
      .required("Email is required"),
    // idType: Yup.string(),
    // idNumber: Yup.string().when(["idType"], {
    //   is: (idType) => idType !== "",
    //   then: Yup.string().required(
    //     "This field is required when Personal ID type is selected."
    //   ),
    //   otherwise: Yup.string().notRequired(),
    // }),
    gender: Yup.string().required("This field is required"),
    // companyStaffId: Yup.string().when(["idType", "idNumber"], {
    //   is: (idType, idNumber) => idType === "" || idNumber === "",
    //   then: Yup.string().required(
    //     "This field is required if no Personal ID given."
    //   ),
    //   otherwise: Yup.string().notRequired(),
    // }),
  }
  // [["idNumber", "idType"], ["idType"], ["companyStaffId"]]
);

export const updateProfileSchema = Yup.object().shape({
  fullName: Yup.string(),
  firstName: Yup.string().required("This field is required"),
  lastName: Yup.string().required("This field is required"),
  // username: Yup.string().required("This field is required"),
  location: Yup.object().shape({
    address: Yup.string(),
    longitude: Yup.number(),
    latitude: Yup.number(),
    city: Yup.string().required("This field is required!"),
    state: Yup.string().required("This field is required!"),
    country: Yup.string().required("This field is required!"),
  }),
  // city: Yup.string().required("This field is required"),
  // state: Yup.string().required("This field is required"),
  // idType: Yup.string().required("This field is required"),
  // idNumber: Yup.string().required("This field is required"),
  // country: Yup.string().required("This field is required"),
  gender: Yup.string().required("This field is required"),
  emergencyContact: Yup.object().shape({
    name: Yup.string().required("This field is required!"),
    phoneNumber: Yup.string().required("This field is required!"),
  }),
  // name: Yup.string().required("This field is required"),
});

export const memberSchema = Yup.object().shape({
  gender: Yup.string().required("This field is required"),
  fName: Yup.string().required("This field is required"),
  email: Yup.string()
    .email()
    .required("This field is required")
    .email("Invalid email"),

  lName: Yup.string().required("This field is required"),
  // memberID: Yup.string().required("This field is required"),
  memberType: Yup.string().required("This field is required"),
  tribeMembershipCat: Yup.string(),
  tribelets: Yup.string(),
  primeMemberID: Yup.string().when("memberType", {
    is: (memberType) => memberType === "squad",
    then: Yup.string().required(
      "Prime resident is required for squad member type"
    ),
    otherwise: Yup.string(),
  }),
});

export const createUserRoleSchema = Yup.object().shape({
  firstName: Yup.string().required("This field is required"),
  lastName: Yup.string().required("This field is required"),
  email: Yup.string().email("Enter a valid email").notRequired(),
  // .required("This field is required"),
  gender: Yup.string().required("Please choose a gender"),
  role: Yup.string().required("Please specify a role"),
  username: Yup.string().notRequired(),
  categoryId: Yup.string().notRequired(),
});

export const hardwareSetupSchema = Yup.object().shape({
  hardwareType: Yup.string().required("This field is required."),
  vendor: Yup.string().required("This field is required."),
  communityId: Yup.string().required(
    "Could not find community Id for this community."
  ),
});

export const impersonationSchema = Yup.object().shape({
  password: Yup.string().required("Password is required to continue"),
});

export const denyRequestSchema = Yup.object().shape({
  reason: Yup.string().required("This field is required"),
});

export const denyWithDetailsSchema = Yup.object().shape({
  reason: Yup.string().required("This field is required"),
  details: Yup.string().notRequired(),
});

export const residentInviteSchema = Yup.object().shape({
  // tribelets: Yup.string().required("This field is required"),
  fName: Yup.string().required("This field is required"),
  email: Yup.string().required("This field is required").email("Invalid email"),
  lName: Yup.string().required("This field is required"),
  unitRel: Yup.string().required("This field is required."),
  unitOfResident: Yup.string().required("Specify a unit to add resident."),
  residentType: Yup.string().required("Please specify resident type"),
  gender: Yup.string().required("This field is required."),
});

export const residentSchema = Yup.object().shape({
  units: Yup.string().required("This field is required"),
  estate_phone: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .max(14, "Incorrect phone number")
    .required("Please enter your phone number"),
  landmark: Yup.string().required("This field is required"),
  city: Yup.string().required("This field is required"),
  man_name: Yup.string().required("This field is required"),
  man_phone: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Please enter your phone number")
    .max(14, "Incorrect phone number"),

  man_email: Yup.string()
    .email()
    .required("This field is required")
    .email("Invalid email"),
  estate_name: Yup.string().required("This field is required"),
  estate_address: Yup.string().required("This field is required"),
  country: Yup.string().required("This field is required"),
});

export const tribeleteSchema = Yup.object().shape({
  tribeletName: Yup.string().required("This field is required"),
});

export const clusterSchema = Yup.object().shape({
  clusterName: Yup.string().required("This field is required"),
  address: Yup.string(),
  man_email: Yup.string()
    .email()
    .required("This field is required")
    .email("Invalid email"),
  man_name: Yup.string().required("This field is required"),
  // man_phone: Yup.string()
  //   .matches(phoneRegExp, "Phone number is not valid")
  //   .max(14, "Incorrect phone number")
  //   .min(10, "Enter full number with +233")
  //   .required("Please enter your phone number"),
  landmark: Yup.string(),
  country: Yup.string().required("This field is required"),
  city: Yup.string().required("This field is required"),
  state: Yup.string().required("This field is required"),
});

export const estateSchema = Yup.object().shape({
  landmark: Yup.string(),
  city: Yup.string().required("This field is required"),
  man_name: Yup.string().required("This field is required"),
  man_email: Yup.string()
    .email()
    .required("This field is required")
    .email("Invalid email"),
  state: Yup.string().required("This field is required"),
  estate_name: Yup.string().required("This field is required"),
  estate_address: Yup.string(),
  country: Yup.string().required("This field is required"),
});

export const editestateSchema = Yup.object().shape({
  city: Yup.string().required("This field is required"),
  state: Yup.string().required("This field is required"),
  estate_name: Yup.string().required("This field is required"),
  estate_address: Yup.string(),
  country: Yup.string().required("This field is required"),
});

export const createtribeSchema = Yup.object().shape({
  landmark: Yup.string(),
  type: Yup.string().required("This field is required"),
  city: Yup.string().required("This field is required"),
  man_name: Yup.string().required("This field is required"),
  man_email: Yup.string()
    .email()
    .required("This field is required")
    .email("Invalid email"),
  state: Yup.string().required("This field is required"),
  tribe_name: Yup.string().required("This field is required"),
  tribe_address: Yup.string(),
  country: Yup.string().required("This field is required"),
});

export const tribeSchema = Yup.object().shape({
  type: Yup.string().required("This field is required"),
  estate_phone: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .max(14, "Incorrect phone number")
    .min(10, "Enter full number with +233")
    .required("Please enter your phone number"),
  landmark: Yup.string().required("This field is required"),
  city: Yup.string().required("This field is required"),
  man_name: Yup.string().required("This field is required"),
  man_phone: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .max(14, "Incorrect phone number")
    .min(10, "Enter full number with +233")

    .required("Please enter your phone number"),
  man_email: Yup.string()
    .email()
    .required("This field is required")
    .email("Invalid email"),
  estate_name: Yup.string().required("This field is required"),
  estate_address: Yup.string().required("This field is required"),
  country: Yup.string().required("This field is required"),
});

export const facilitySchema = Yup.object().shape({
  category: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  name: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  description: Yup.string().typeError("Invalid value"),
  notices: Yup.string().typeError("Invalid value"),
  size: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  capacity: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  features: Yup.array()
    .of(Yup.string())
    .required("This field is required!")
    .typeError("Invalid value"),
  purchaseOptions: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  location: Yup.object().shape({
    address: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    longitude: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    latitude: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    city: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    state: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    country: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
  }),
  requiresBooking: Yup.boolean()
    .required("This field is required!")
    .typeError("Invalid value"),
  availability: Yup.object().shape({
    timeZone: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    timePerSlot: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    bufferTime: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    maxBookingsPerSlot: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    schedule: Yup.object().shape({
      monday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string("")
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      tuesday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      wednesday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      thursday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      friday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      saturday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      sunday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
    }),
    slots: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().typeError("Invalid value"),
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingAmount: Yup.number()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingCurrencyCode: Yup.string().typeError("Invalid value"),
      })
    ),
    customSlots: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().typeError("Invalid value"),
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingAmount: Yup.number()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingCurrencyCode: Yup.string().typeError("Invalid value"),
        override: Yup.boolean()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    customSlotDays: Yup.array()
      .of(Yup.string().required("This field is required!"))
      .typeError("Invalid value"),
    customSlotDateRanges: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    maxBookingsPerUser: Yup.number().typeError("Invalid value"),
    bookingRestrictionPeriod: Yup.string().typeError("Invalid value"),
  }),
});

export const updateFacilitySchema = Yup.object().shape({
  category: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  name: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  description: Yup.string().typeError("Invalid value"),
  notices: Yup.string().typeError("Invalid value"),
  size: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  capacity: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  features: Yup.array()
    .of(Yup.string())
    .required("This field is required!")
    .typeError("Invalid value"),
  location: Yup.object().shape({
    address: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    longitude: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    latitude: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    city: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    state: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    country: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
  }),
  requiresBooking: Yup.boolean()
    .required("This field is required!")
    .typeError("Invalid value"),
  availability: Yup.object().shape({
    timeZone: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    timePerSlot: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    bufferTime: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    maxBookingsPerSlot: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    schedule: Yup.object().shape({
      monday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string("")
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      tuesday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      wednesday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      thursday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      friday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      saturday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      sunday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
    }),
    slots: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().notRequired(),
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingAmount: Yup.number()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingCurrencyCode: Yup.string().typeError("Invalid value"),
      })
    ),
    customSlots: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().notRequired(),
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingAmount: Yup.number()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingCurrencyCode: Yup.string().typeError("Invalid value"),
        override: Yup.boolean()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    customSlotDays: Yup.array()
      .of(Yup.string().required("This field is required!"))
      .typeError("Invalid value"),
    customSlotDateRanges: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    maxBookingsPerUser: Yup.number().typeError("Invalid value"),
    bookingRestrictionPeriod: Yup.string().typeError("Invalid value"),
  }),
});

export const availabilitySchema = Yup.object().shape({
  category: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  name: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  description: Yup.string().typeError("Invalid value"),
  notices: Yup.string().typeError("Invalid value"),
  size: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  capacity: Yup.string()
    .required("This field is required!")
    .typeError("Invalid value"),
  features: Yup.array()
    .of(Yup.string().required("This field is required!"))
    .typeError("Invalid value"),
  location: Yup.object().shape({
    address: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    longitude: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    latitude: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    city: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    state: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    country: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
  }),
  requiresBooking: Yup.boolean().required("This field is required!"),
  availability: Yup.object().shape({
    timeZone: Yup.string()
      .required("This field is required!")
      .typeError("Invalid value"),
    timePerSlot: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    bufferTime: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    maxBookingsPerSlot: Yup.number()
      .required("This field is required!")
      .typeError("Invalid value"),
    schedule: Yup.object().shape({
      monday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      tuesday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      wednesday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      thursday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      friday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      saturday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
      sunday: Yup.array().of(
        Yup.object().shape({
          startTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
          endTime: Yup.string()
            .required("This field is required!")
            .typeError("Invalid value"),
        })
      ),
    }),
    slots: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingAmount: Yup.number()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingCurrencyCode: Yup.string().typeError("Invalid value"),
      })
    ),
    customSlots: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().typeError("Invalid value"),
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingAmount: Yup.number()
          .required("This field is required!")
          .typeError("Invalid value"),
        pricingCurrencyCode: Yup.string().typeError("Invalid value"),
        overrideSlot: Yup.boolean()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    customSlotDays: Yup.array()
      .of(Yup.string().required("This field is required!"))
      .typeError("Invalid value"),
    customSlotDateRanges: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    maxBookingsPerUser: Yup.number().typeError("Invalid value"),
    bookingRestrictionPeriod: Yup.string().typeError("Invalid value"),
  }),
});

export const moveLargeItemsSchema = Yup.object().shape({
  // estateId: Yup.string().required("This field is required").typeError("Invalid value"),
  address: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  startDate: Yup.string()
    .required("This field is required")
    .test(
      "isBeforeEndDate",
      "Start time should be before end time",
      (startDate, testContext) =>
        moment(startDate).diff(moment(testContext.parent.endDate), true) < 0
    )
    .typeError("Invalid value"),
  endDate: Yup.string()
    .required("This field is required")
    .test(
      "isBeforeStartDate",
      "End time should be after start time",
      (endDate, testContext) =>
        moment(endDate).diff(moment(testContext.parent.startDate), true) > 0
    )
    .typeError("Invalid value"),
  entryType: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  vehicleType: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  description: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  contactNumber: Yup.string().typeError("Invalid value"),
  coordinatorName: Yup.string().typeError("Invalid value"),
  coordinatorNumber: Yup.string().typeError("Invalid value"),
  verificationMethods: Yup.array()
    .of(
      Yup.object().shape({
        method: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        type: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        value: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    )
    .unique("Duplicate values", (a) => a.type),
  additionalComments: Yup.string().typeError("Invalid value"),
});

export const editMoveLargeItemsSchema = Yup.object().shape({
  // estateId: Yup.string().required("This field is required").typeError("Invalid value"),
  // address: Yup.string().required("This field is required").typeError("Invalid value"),
  startDate: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  endDate: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  entryType: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  vehicleType: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  description: Yup.string()
    .required("This field is required")
    .typeError("Invalid value"),
  contactNumber: Yup.string().typeError("Invalid value"),
  coordinatorName: Yup.string().typeError("Invalid value"),
  coordinatorNumber: Yup.string().typeError("Invalid value"),
  verificationMethods: Yup.array()
    .of(
      Yup.object().shape({
        type: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        value: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    )
    .unique("Duplicate values", (a) => a.type),
  additionalComments: Yup.string().typeError("Invalid value"),
});

export const addPaymentCategorySchema = Yup.object().shape({
  name: Yup.string().required("This field is required."),
  applicableUsers: Yup.array()
    .min(1, "Select at least one applicable user")
    .required("This field is required."),
});

export const manualRecipientAdditionSchema = Yup.object().shape({
  name: Yup.string().required("This field is required."),
  email: Yup.string()
    .email("Email is invalid")
    .required("This field is required."),
});

export const createManualReceiptSchema = Yup.object().shape({
  amount: Yup.number().required("This field is required."),
  dueDate: Yup.string().required("This field is required."),
  issuerId: Yup.string().optional(),
  billerEntityId: Yup.string().required("This field is required."),
  templateStyle: Yup.string().required("This field is required."),
  templateId: Yup.string(),
  paymentCategoryId: Yup.string().required("This field is required."),
  templateInvoice: Yup.object()
    .shape({
      title: Yup.string().required("This field is required."),
      description: Yup.string().required("This field is required."),
      issuedAt: Yup.string().required("This field is required."),
      amount: Yup.number().required("This field is required."),
      lineItems: Yup.array()
        .min(1, "Specify at least one payment item.")
        .required("This field is required."),
    })
    .required("This field is required."),
});

export const createManualPaymentSchema = Yup.object().shape({
  amount: Yup.number().required("This field is requierd."),
  dueDate: Yup.string().required("This field is required."),
  issuerId: Yup.string().required("This field is required."),
  billerEntityId: Yup.string().optional(),
  templateStyle: Yup.string().required("This field is required."),
  templateId: Yup.string().notRequired(),
  paymentCategoryId: Yup.string().required("This field is required."),
  templateInvoice: Yup.object()
    .shape({
      title: Yup.string().required("This field is required."),
      description: Yup.string().required("This field is required."),
      issuedAt: Yup.string().required("This field is required."),
      amount: Yup.number().required("This field is required."),
      lineItems: Yup.array()
        .min(1, "Specify at least one payment item.")
        .required("This field is required."),
    })
    .required("This field is required."),
  settlementAccount: Yup.object().shape({
    accountNumber: Yup.number("This field can only contain numbers.").required(
      "This field is required."
    ),
    accountName: Yup.string()
      .required("This field is required.")
      .matches(
        /^[a-zA-Zs -]+$/,
        "Account name cannot be numbers only or contain special characters."
      ),
    bank: Yup.string()
      .required("This field is required.")
      .matches(
        /^[a-zA-Zs -]+$/,
        "Bank name cannot be numbers only or contain special characters."
      ),
    branch: Yup.string()
      .required("This field is required.")
      .matches(
        /^[a-zA-Zs -]+$/,
        "Branch cannot be numbers only or contain special characters."
      ),
    internationalBankAddress: Yup.string()
      .notRequired()
      .matches(
        /^[a-zA-Zs ,-]+$/,
        "Bank Address cannot be numbers only or contain special characters."
      ),
    internationalRoutingNumbers: Yup.number(
      "This field can only contain numbers."
    ).notRequired(),
    swift: Yup.number("This field can only contain numbers.").notRequired(),
    IntermediateBank: Yup.string()
      .notRequired()
      .matches(
        /^[a-zA-Zs -]+$/,
        "Intermediate Bank name cannot be numbers only or contain special characters."
      ),
  }),
});

export const configureSettlementSchema = Yup.object().shape({
  billerEntities: Yup.array()
    .min(1, "Select at least one biller entity")
    .required("This field is required."),
  billerEntityGroupId: Yup.string().required("This field is required."),
  settlementOption: Yup.string().required("This field is required."),

  countDownDuration: Yup.number().when("settlementOption", {
    is: (settlementOption) => settlementOption === "auto",
    then: Yup.number()
      .min(1, "Number cannot be less than 1")
      .required("This field is required."),
    otherwise: Yup.number(),
  }),

  dueDateMetric: Yup.number().when("settlementOption", {
    is: (settlementOption) => settlementOption === "auto",
    then: Yup.number().required("This field is required."),
    otherwise: Yup.number(),
  }),

  dueDateTimeFrame: Yup.number().when("settlementOption", {
    is: (settlementOption) => settlementOption === "auto",
    then: Yup.number().required("This field is required."),
    otherwise: Yup.number(),
  }),

  dueDateTerminus: Yup.number().when("settlementOption", {
    is: (settlementOption) => settlementOption === "auto",
    then: Yup.number().required("This field is required."),
    otherwise: Yup.number(),
  }),
});

export const addAdhocInvoiceSchema = Yup.object({
  name: Yup.string().required(VALIDATION_TEXTS.REQUIRED),
  billConfigurationId: Yup.string().required(VALIDATION_TEXTS.REQUIRED),
  templateInvoiceId: Yup.string().required(VALIDATION_TEXTS.REQUIRED),
  billerEntities: Yup.array()
    .of(Yup.string())
    .min(1, VALIDATION_TEXTS.REQUIRED),
});

export const addBillerGroupSchema = Yup.object().shape({
  name: Yup.string().required("This field is required."),
  // associatedProfile: Yup.number(),
  applicableProfiles: Yup.array()
    .min(1, "Select at least one applicable profile")
    .required("This field is required."),
  associatedProfiles: Yup.array()
    .min(1, "Select at least one applicable role")
    .required("This field is required."),
});

export const addRestrictionSchema = Yup.object().shape({
  name: Yup.string().required("This field is required."),
  applicableGroups: Yup.array()
    .min(1, "Select at least one applicable entity group")
    .required("This field is required."),
});

export const addBillConfigSchema = Yup.object().shape({
  title: Yup.string().required("This field is required."),
  duePeriod: Yup.string().required("This field is required."),
  categoryId: Yup.string().required("This field is required."),

  // Payment flexibility is no longer required
  // flexibility: Yup.array()
  //   .min(1, "Select at least one flexibility type")
  //   .required("This field is required."),

  // There can now be no grace period on a bill configuration
  // gracePeriod: Yup.number()
  //   .min(1, "Period figure cannot be 0")
  //   .required("Please specify a grace period. "),
  gracePeriodMetric: Yup.number().required("Grace period method is required"),
  restrictions: Yup.array(),
});

export const settlementAccountDetailsSchema = Yup.object().shape({
  accountName: Yup.string().required("Account Name is required."),
  accountNumber: Yup.number()
    .required("Account Number is required")
    .typeError("Account number cannot contain letters"),
  bank: Yup.string().required("Bank name is required"),
  branch: Yup.string().required("Bank Branch is required"),
  routingNumbers: Yup.number()
    .notRequired()
    .typeError("This field cannot contain letters"),
  addInternationalTransfers: Yup.boolean(),
  bankAddress: Yup.string().when("addInternationalTransfers", {
    is: (addInternationalTransfers) => addInternationalTransfers === true,
    then: Yup.string().required(
      "Specifiy a Bank Address for International Transfers"
    ),
    otherwise: Yup.string(),
  }),
  intermediaryBankRoutingNumbers: Yup.number(
    "Routing numbers cannot contain letters"
  ).when("addInternationalTransfers", {
    is: (addInternationalTransfers) => addInternationalTransfers === true,
    then: Yup.number()
      .required("This field is required")
      .typeError("This field cannot contain letters"),
    otherwise: Yup.number()
      .notRequired()
      .typeError("This field cannot contain letters"),
  }),
  swift: Yup.string().when("addInternationalTransfers", {
    is: (addInternationalTransfers) => addInternationalTransfers === true,
    then: Yup.string().required(
      "Swift is required for International Transfers"
    ),
    otherwise: Yup.string(),
  }),
  intermediaryBank: Yup.string().when("addInternationalTransfers", {
    is: (addInternationalTransfers) => addInternationalTransfers === true,
    then: Yup.string().required(
      "Intermediary Bank is required for International Transfers"
    ),
    otherwise: Yup.string(),
  }),
  description: Yup.string().required(
    "Please add a description of this account."
  ),
  recipientswift: Yup.string().notRequired(),
  recipientintermediaryBank: Yup.string().notRequired(),
  recipientintermediaryBankRoutingNumbers: Yup.string().notRequired(),
  recipientbankAddress: Yup.string().notRequired(),
});

export const billerEntitySchema = Yup.object().shape({
  name: Yup.string()
    .required("This field is required")
    .matches(REGEXES.HAS_LETTERS_WITH_HYPHEN_SPACE, "Can contain only letters"),
  primaryContact: Yup.string().notRequired(),
  primaryContactEmailAddress: Yup.string().notRequired(),
  businessAddress: Yup.string().notRequired(),
  billerEntityGroupId: Yup.string().required("This field is required"),
  billerEntityGroup: Yup.string().notRequired(),
  settlementAccountId: Yup.string().notRequired().nullable(),
  title: Yup.string()
    .notRequired()
    .matches(REGEXES.HAS_LETTERS_WITH_HYPHEN_SPACE, "Can contain only letters"),
  accountNumber: Yup.string()
    .notRequired()
    .matches(REGEXES.IS_NUMBERS_ONLY, "Can contain only numbers"),
  accountName: Yup.string()
    .notRequired()
    .matches(REGEXES.HAS_LETTERS_WITH_HYPHEN_SPACE, "Can contain only letters"),
  bank: Yup.string()
    .notRequired()
    .matches(REGEXES.HAS_LETTERS_WITH_HYPHEN_SPACE, "Can contain only letters"),
  bankCode: Yup.string().notRequired(),
  branch: Yup.string()
    .notRequired()
    .matches(REGEXES.HAS_LETTERS_WITH_HYPHEN_SPACE, "Can contain only letters"),
  description: Yup.string().notRequired(),
  routingNumbers: Yup.string()
    .notRequired()
    .matches(REGEXES.IS_NUMBERS_ONLY, "Can contain only letters"),
  intermediaryBank: Yup.string()
    .notRequired()
    .matches(REGEXES.HAS_LETTERS_WITH_HYPHEN_SPACE, "Can contain only letters"),
  bankAddress: Yup.string().notRequired(),
  swift: Yup.string()
    .notRequired()
    .matches(REGEXES.IS_NUMBERS_ONLY, "Can contain only letters"),
  intermediaryBankRoutingNumbers: Yup.string()
    .notRequired()
    .matches(REGEXES.IS_NUMBERS_ONLY, "Can contain only letters"),
  billerEntityId: Yup.string().notRequired(),
  primaryEmailAddress: Yup.string()
    .notRequired()
    .matches(REGEXES.EMAIL, "Invalid input"),
  primaryPhoneNumber: Yup.string()
    .notRequired()
    .matches(REGEXES.PHONE_NUMBER, "Invalid phone number"),
  secondaryEmailAddress: Yup.string()
    .notRequired()
    .matches(REGEXES.EMAIL, "Invalid input"),
  secondaryPhoneNumber: Yup.string()
    .notRequired()
    .matches(REGEXES.PHONE_NUMBER, "Invalid phone number"),
  recipientintermediaryBank: Yup.string()
    .notRequired()
    .matches(REGEXES.HAS_LETTERS_WITH_HYPHEN_SPACE, "Can contain only letters"),
  recipientswift: Yup.string()
    .notRequired()
    .matches(REGEXES.IS_NUMBERS_ONLY, "Can contain only letters"),
  recipientintermediaryBankRoutingNumbers: Yup.string()
    .notRequired()
    .matches(REGEXES.IS_NUMBERS_ONLY, "Can contain only letters"),
  recipientbankAddress: Yup.string().notRequired(),
});

export const businessHoursSchema = Yup.object().shape({
  businessHours: Yup.object().shape({
    monday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string("")
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    tuesday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    wednesday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    thursday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    friday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    saturday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
    sunday: Yup.array().of(
      Yup.object().shape({
        startTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
        endTime: Yup.string()
          .required("This field is required!")
          .typeError("Invalid value"),
      })
    ),
  }),
});

export const engagementCommunitySetupSchema = Yup.object().shape({
  name: Yup.string().required("This field is required."),
  description: Yup.string().required("This field is required."),
  rule: Yup.string().required("This field is required."),
});

export const createCircleSchema = Yup.object().shape({
  name: Yup.string().required("This field is required."),
  description: Yup.string().required("This field is required."),
  rule: Yup.string().required("This field is required."),
  membershipType: Yup.string().required("This field is required."),
});

export const createHiveSchema = Yup.object().shape({
  name: Yup.string().required("This field is required."),
  description: Yup.string().required("This field is required."),
  color: Yup.string().required("This field is required."),
  imageUrl: Yup.string().required("This field is required."),
});
